module.exports = __webpack_public_path__ + "static/tile-two.64bb7a15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tile-two.jpg
// module id = 71
// module chunks = 168707334958949